import LogRocket from 'logrocket';
import logger from './logger';
import { getErrorMessage } from './errorUtils';
import { requestSanitizer, responseSanitizer } from './logRocketUtils';

// shared by both pages (src/index.js and src/funnelIndex.js), so a session is recorded with the same
// release and the same card and health-field sanitizers whichever page the customer landed on
export const initializeLogRocket = () => {
	try {
		LogRocket.init(process.env.REACT_APP_LOGROCKET_ID, {
			release: process.env.REACT_APP_VERSION,
			shouldDebugLog: false,
			dom: {
				baseHref: 'https://app.readyrx.com/',
			},
			network: {
				requestSanitizer: requestSanitizer,
				responseSanitizer: responseSanitizer,
			},
		});
	} catch (err) {
		logger.logErrorEvent('LOG_ROCKET_INITIALIZATION', err, getErrorMessage(err), true);
	}
};
